<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content">
      <!--  bg-image-self -->
      <!-- <div v-if="this.$store.state.permit.RulesUser.roles.includes('staff')"></div> -->
      <div class="container">
        <Keypress
          :multiple-keys="multiple"
          key-event="keyup"
          @success="checkselfScan"
          @wrong="otherMethod"
        />
      </div>
      <div class="container-fulid" style="width: 99%">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <h3 style="font-weight: 100" class="mt-5 font-en mb-1">
              <strong class="font-en font-weight-bold">Check-in</strong>
            </h3>
            <h5 style="font-weight: 100" class="mt-1 font-en mb-1">
              <!-- <strong class="font-en font-weight-bold">text.....</strong> -->
            </h5>
            <p class="mt-1 mb-5 font-en text-danger">
              *** Support student graduate only ***
            </p>
            <b-media>
              <template #aside>
                <img
                  v-if="objSelfCheck.id === ''"
                  class="thumbnail"
                  src="@/assets/img/avatar.png"
                  style="width: 250px; height: 300px"
                  alt="icon_std"
                />
                <b-img
                  v-else
                  thumbnail
                  style="width: 250px; height: 300px"
                  v-bind:src="`https://icapp.muic.mahidol.ac.th/source/pic/${objSelfCheck.id}.jpg`"
                  alt="muicAvtar"
                ></b-img>
              </template>
              <h5 class="mt-3 mb-4 font-weight-bold">
                <i class="fa fa-address-card-o fa-2x" aria-hidden="true" />
              </h5>
              <b-input-group size="lg">
                <template #prepend>
                  <b-input-group-text class="font-en"
                    >STUDENT : ID</b-input-group-text
                  >
                </template>
                <b-form-input
                  v-model="valKeyInput"
                  type="number"
                ></b-form-input>
                <b-input-group-append>
                  <!-- <b-button :disabled="valKeyInput === ''" @click="checkselfBtn" size="lg" class="font-en" variant="success">Add</b-button> -->
                  <b-button
                    @click="reloadpage"
                    size="lg"
                    class="font-en"
                    variant="danger"
                    >clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
              <!-- error msg -->
              <b-alert
                v-if="msgerror"
                class="mt-4 mb-3"
                show
                variant="dangercus"
                dismissible
              >
                <h5 class="font-en mt-2 mb-2">
                  Please try to scan your again.
                </h5>
                <p class="font-thai mt-1 mb-2">โปรดลองสแกนอีกครั้ง</p>
              </b-alert>
              <!-- <pre>{{ objSelfCheck }}</pre> -->
              <b-alert class="mt-2" show variant="infoP">
                <p class="mt-2 font-en-chk">Detail:</p>
                <hr />
                <h2 class="font-en mt-2 mb-3 ml-3">
                  Graduation Number :
                  <span class="font-weight-bold text-white ml-2">{{
                    objSelfCheck.order
                  }}</span>
                </h2>
                <h5
                  v-if="objSelfCheck.id !== '0000'"
                  class="font-en mt-1 mb-2 ml-3"
                >
                  ID : {{ objSelfCheck.id }}
                </h5>
                <h5 class="font-en mt-1 mb-2 ml-3">
                  Name : {{ objSelfCheck.name }}
                </h5>
                <h5 class="font-en mt-1 mb-2 ml-3">
                  Major : {{ objSelfCheck.major }}
                </h5>
                <!--  
                    <p class="font-en mt-1 mb-2 ml-3">
                    <span class="text-muted" v-if="objSelfCheck.status === ''"
                        >SCAN CARD ID</span
                    >
                    <span v-if="objSelfCheck.status === 'pass'"
                        >Status : Pass</span
                    >
                    <span class="font-thai" v-if="objSelfCheck.status === 'DUPP'"
                        >Status : ท่านได้ส่ง Nakhon Pathom's Self-Screening Form
                        เรียบร้อยเเล้ว</span
                    >
                    <span v-if="objSelfCheck.status === 'failed'"
                        >Status : Not Pass</span
                    >
                    </p>
                -->
              </b-alert>
              <div class="row mt-3 mb-3">
                <!--  
                  <div class="col-sm-12 col-md-6">
                    <b-alert
                      v-if="objSelfCheck.status !== ''"
                      class="mt-2"
                      show
                      :variant="
                        objSelfCheck.status === 'pass'
                          ? 'successcus'
                          : 'dangercus'
                      "
                    >
                      <h5 class="text-dark font-en-chk font-weight-bold mb-1">
                        Antigen test kit [ ATK ]
                      </h5>
                      <hr class="mt-1 mb-1" />
                      <h5 class="text-dark font-en-chk mt-0 mb-1">
                        Your ATK result :
                        <strong>{{ objSelfCheck.status }}</strong>
                      </h5>
                    </b-alert>
                  </div>
                -->
                <div class="col-sm-12 col-md-6">
                  <b-alert
                    v-if="objSelfCheck.statusB !== ''"
                    class="mt-2"
                    show
                    :variant="objSelfCheck.statusB ? 'successcus' : 'dangercus'"
                  >
                    <h5 class="text-dark font-en-chk font-weight-bold mb-1">
                      Employment Survey
                    </h5>
                    <hr class="mt-1 mb-1" />
                    <h5 class="text-dark font-en-chk mt-0 mb-1">
                      Your Employment Survey result :
                      <strong>{{
                        objSelfCheck.statusB ? "Done" : "Not Done"
                      }}</strong>
                    </h5>
                  </b-alert>
                </div>
              </div>
            </b-media>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal DUPPLICATION -->
    <!--  
            <b-modal ref="modal-dupplication" header-bg-variant="info" header-text-variant="light" hide-footer>
                <template v-slot:modal-title>
                    <h4 class="font-thai mt-1 mb-2">
                        <i class="fa fa-info fa-lg" aria-hidden="true" />
                    </h4>
                </template>
                <b-card-text class="text-center mb-3">
                    <h4 class="font-thai mt-2 mb-1">
                        <i class="fa fa-check mr-2 text-success" aria-hidden="true" />ท่านได้ส่ง
                    </h4>
                    <h5 class="font-en mt-2 mb-1"><strong>Nakhon Pathom's Self-Screening Form</strong></h5>
                </b-card-text>
            </b-modal>
        -->
    <!-- Modal No Content -->
    <b-modal
      ref="modal-nocontent"
      header-bg-variant="danger"
      header-text-variant="light"
      hide-footer
    >
      <template v-slot:modal-title>
        <h4 class="font-thai mt-1 mb-2">ไม่พบข้อมูล</h4>
      </template>
      <b-card-text class="mb-3">
        <h5 class="font-thai mt-1 mb-2">โปรดตรวจสอบรายชื่อ</h5>
      </b-card-text>
    </b-modal>
    <!-- Modal new -->
    <!--  
            <b-modal ref="modal-new" hide-footer>
                <template v-slot:modal-title>
                    <h5 class="mt-1 mb-1">
                        <strong class="font-thai"><i class="fa fa-user mr-1" aria-hidden="true"/>นักศึกษาใหม่</strong>
                    </h5>
                </template>
                <b-card-text class="mb-3">
                    <h5 class="font-thai mt-1 mb-2">ระบุ รหัสนักศึกษา</h5>
                    <b-form-input size="lg" v-model="addNewID" type="number"></b-form-input>
                    <div class="mt-3" v-if="loadADD">
                        <b-spinner small type="grow"></b-spinner><span class="ml-1 font-thai font-s-1">กำลังดำเนินการเพิ่มข้อมูล</span>
                    </div>
                    <div v-else>
                        <div class="mt-3 text-right">
                            <b-button :disabled="addNewID === ''" class="mr-3 font-thai font-s-1 mt-0 text-dark" variant="warning">
                                <i class="fa fa-plus mr-1" aria-hidden="true"/>เพิ่มข้อมูล
                            </b-button>
                            <b-button class="font-thai font-s-1 mt-0" @click="closeModalNewStd" variant="danger">
                                ปิด
                            </b-button>
                        </div>
                    </div>
                </b-card-text>
            </b-modal>
        -->
  </div>
</template>

<script>
export default {
  components: {
    Keypress: () => import("vue-keypress"),
  },
  computed: {
    getTokenUrl() {
      return typeof this.$route.query.location === "undefined" ||
        this.$route.query.location === ""
        ? "Not spectify location"
        : this.$route.query.location;
    },
  },
  data() {
    return {
      msgerror: false,
      loadADD: false,
      valKey: "",
      valKeyInput: "",
      valTemp: "Key name",
      multiple: [
        {
          keyCode: 13, // Enter
          modifiers: [],
          preventDefault: true,
        },
      ],
      addNewID: "",
      objSelfCheck: {
        id: "",
        status: "",
        name: "",
        major: "",
        order: "",
        practise: "",
        statusAtk: "",
        statusB: "",
      },
    };
  },
  methods: {
    reloadpage() {
      location.reload();
    },
    modalNewStd() {
      this.addNewID = "";
      this.$refs["modal-new"].show();
    },
    closeModalNewStd() {
      this.addNewID = "";
      this.$refs["modal-new"].hide();
    },
    clearDataObj() {
      this.valKey = "";
      this.valKeyInput = "";
      this.objSelfCheck.id = "";
      this.objSelfCheck.status = "";
      this.objSelfCheck.name = "";
      this.objSelfCheck.major = "";
      this.objSelfCheck.order = "";
      this.objSelfCheck.practise = "";
      this.objSelfCheck.statusAtk = "";
      this.objSelfCheck.statusB = "";
      this.$refs["modal-nocontent"].hide();
      // this.$refs['modal-dupplication'].hide()
    },
    async checkselfBtn() {
      this.valKey = this.valKeyInput;
      this.checkselfScan();
    },
    chekArrAtk(arr) {
      let arrReult = [];
      for (let a = 0; a < arr.length; a++) {
        const element = arr[a];
        arrReult.push(element.status);
      }
      return arrReult.includes("pass");
    },
    async checkselfScan(response) {
      this.objSelfCheck.id = "";
      this.objSelfCheck.status = "";
      this.objSelfCheck.name = "";
      this.objSelfCheck.major = "";
      this.objSelfCheck.order = "";
      this.objSelfCheck.practise = "";
      this.objSelfCheck.statusAtk = "";
      this.objSelfCheck.statusB = "";
      try {
        this.valKeyInput = this.valKey;
        const resSCAN = await this.$http.get(
          `/graduate-atk/profile/${this.valKey}/check/?location=${this.getTokenUrl}`
          //  /graduate-atk/profile/{id}/check/
        );
        this.valKey = "";
        this.valKeyInput = "";
        if (resSCAN.status === 200) {
          this.objSelfCheck.id = resSCAN.data.code_id_detail.user_code;
          this.objSelfCheck.status = resSCAN.data.status;
          this.objSelfCheck.name = `${resSCAN.data.code_id_detail.title_en} ${resSCAN.data.code_id_detail.name_en}`;
          this.objSelfCheck.major = `${resSCAN.data.code_id_detail.major_en} , ${resSCAN.data.code_id_detail.major_th}`;
          this.objSelfCheck.order = resSCAN.data.code_id_detail.present_order;
          this.objSelfCheck.practise = resSCAN.data.code_id_detail.practise;
          this.objSelfCheck.statusAtk = resSCAN.data.status;
          this.objSelfCheck.statusB = resSCAN.data.code_id_detail.form_survey;
        } else if (resSCAN.status === 204) {
          this.$refs["modal-nocontent"].show();
        }
      } catch (error) {
        this.msgerror = true;
      }
      // clear
      setTimeout(() => this.clearDataObj(), 5000);
    },
    otherMethod(response) {
      // console.log(response.event.keyCode)
      if (response.event.keyCode >= 48 && response.event.keyCode <= 57) {
        var temp = response.event.keyCode - 48;
        this.valKey += `${temp}`;
      } else if (
        response.event.keyCode >= 96 &&
        response.event.keyCode <= 105
      ) {
        var temp = response.event.keyCode - 96;
        this.valKey += `${temp}`;
      } else if (
        response.event.keyCode === 8 ||
        response.event.keyCode === 46
      ) {
        this.valKey = this.valKey.substring(0, this.valKey.length - 1);
      } else if (response.event.keyCode == 188) {
        this.valKey = this.valKey + ",";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@500&family=Sarabun:wght@500&display=swap");
.form-control {
  background-color: #ffffff;
  border: 1px solid #ced4da;
  border-radius: 4px;
  color: #000;
  font-size: 14px;
  transition: background-color 0.3s ease 0s;
  padding: 7px 18px;
  height: 40px;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.font-thai {
  font-family: "Kanit", sans-serif;
  font-weight: 100;
}
.font-s-1 {
  font-size: 1.25rem;
}
.font-en {
  font-family: "Rubik", sans-serif;
  font-weight: 300;
}
.alert-infoP {
  background-color: #433e6d;
  color: #ffffff;
}
.alert-dangercus {
  background-color: #ffcaca;
  color: #000000;
  border-radius: 10px;
}
.alert-successcus {
  background-color: #7cfca9;
  color: #000000;
  border-radius: 10px;
}
// .bg-image-self {
//     background-position: center;
//     background-repeat: no-repeat;
//     background-size: cover;
//     background-image: url("../../assets/img/bg-selfscreen.png");
// }
</style>

